module.exports = __webpack_public_path__ + "static/agus-455a068c13dd0d46b2d3de6390e3792c.jpg";